import { DOMAIN } from '../server/paths';

// API
export const API = DOMAIN + 'api/';
export const API_V1 = API + 'v1/';

// AUTH
export const token = API + 'oauth/token';
export const tokenWithProvider = API + 'oauth/token';
export const logout = API + 'oauth/logout';
export const user = API_V1 + 'user';
export const userRegister = API + 'user-register';
export const forgotPassword = API + 'forgot-password';
export const resetPassword = API + 'reset-password';
export const changePassword = API_V1 + 'change-password';
export const userChangePassword = API_V1 + 'user-change-password';
export const verifyEmail = API + 'verify-email';
export const verifyCode = API + 'verify-code';
export const sendToMail = API + 'send-to-mail';
export const verify2fa = API + 'oauth/verify_2fa';
export const resend2fa = API + 'oauth/resend_2fa';

// PRODUCTS
export const productAll = API + 'products-all';
export const productCreate = API_V1 + 'product-create';
export const productUpdate = API_V1 + 'product-update';
export const productDelete = API_V1 + 'product-delete';
export const productDuplicate = API_V1 + 'product-duplicate';

// DTONE
export const dtoneProducts = API_V1 + 'dtone/products';
export const dtonePromotions = API_V1 + 'dtone/promotions';

// LINKS
export const linkAll = API_V1 + 'links-all';
export const linkCreate = API_V1 + 'link-create';
export const linkUpdate = API_V1 + 'link-update';
export const linkDelete = API_V1 + 'link-delete';
export const linkGet = API + 'get-link';
export const linkPay = API + 'payment-link-redsys';
export const linkPaymentIntention = API_V1 + 'link-payment_intention';

// SETTINGS
export const settingAll = API_V1 + 'settings-all';
export const settingUpdate = API_V1 + 'setting-update';

// USERS
export const userAll = API_V1 + 'users-all';
export const userById = (id) => API_V1 + `user-get/${id}`;
export const userSearch = API_V1 + 'user-search';
export const userCreate = API_V1 + 'user-create';
export const userUpdate = API_V1 + 'user-update';
export const userDelete = API_V1 + 'user-delete';
export const userPoint = API_V1 + 'user-point';

// RECHARGES
export const rechargeAll = API_V1 + 'recharges-all';
export const rechargeCreate = API_V1 + 'recharge-create';
export const rechargeByUser = API_V1 + 'recharges-by-user';
export const getListRechargeByType = API + 'get-list-recharge-by-type';
export const resentRecharge = API_V1 + 'resent-recharge';
export const statusScheduledRecharge = API_V1 + 'status-scheduled-recharge';
export const hiddenRecharge = API_V1 + 'recharge/hidden';

// CONTACTS-RECHARGES
export const rechargeContactsAll = API_V1 + 'contact-recharges-all';
export const rechargeContactsByUser = API_V1 + 'contact-recharges-by-user';
export const rechargeContactsByUserSearch = API_V1 + 'contact-recharges-search';

// OFFERS
export const offerAll = API_V1 + 'offers-all';
export const offerById = (id) => API_V1 + `offer-get/${id}`;
export const offerPublic = API + 'offer-public';
export const offerPublicOnly = API + 'offer-public-only';
export const offerCreate = API_V1 + 'offer-create';
export const offerUpdate = API_V1 + 'offer-update';
export const offerDelete = API_V1 + 'offer-delete';
export const offerAssociateProduct = API_V1 + 'offer-associate-products';

// GROUPS
export const groupAll = API_V1 + 'groups-all';
export const groupGet = API + 'group-get';
export const groupCreate = API_V1 + 'group-create';
export const groupUpdate = API_V1 + 'group-update';
export const groupDelete = API_V1 + 'group-delete';
export const groupAssociateUser = API_V1 + 'user-associate';

// CONTACTS
export const contactsByUser = API_V1 + 'contacts-by-user';
export const contactCreate = API_V1 + 'contact-create';
export const contactLoad = API_V1 + 'contact-load';
export const contactUpdate = API_V1 + 'contact-update';
export const contactUpdateAvatar = API_V1 + 'contact-update-avatar';
export const contactDelete = API_V1 + 'contact-delete';

// INVITATIONS
export const invitesAll = API_V1 + 'invites-all';
export const invitationsByUser = API_V1 + 'get-invite-by-user';
export const invitationGet = API + 'get-invite-link';
export const invitationCreate = API_V1 + 'generate-invite-link';
export const invitationDelete = API_V1 + 'link-delete';

// PROFILE
export const updateAvatar = API_V1 + 'user-update-avatar';
export const userPreferences = API_V1 + 'user-preferences';

// STRIPE
export const paymentStripeClientSecret = API_V1 + 'payment-stripe-setup';
export const paymentStripeSetupIntent = API_V1 + 'payment-stripe-setup-intent';
export const paymentStripeIntention = API_V1 + 'payment-stripe-intention';
export const paymentMethods = API_V1 + 'payment-methods';
export const paymentStripeGetPaymentMethods = API_V1 + 'payment-stripe-get-payment-methods';
export const paymentMethodDelete = API_V1 + 'payment-method-delete';
export const paymentStripeRemovePaymentMethod = API_V1 + 'payment-stripe-remove-payment-method';
export const paymentMethodDefault = API_V1 + 'payment-stripe-method-default';
export const paymentMethodUpdate = API_V1 + 'payment-method-update';

// PAYMENT
export const payment = API_V1 + 'recharge-do';

// REDSYS NOTYFY 3DSMETHOD
export const redsysThreeDSMethod = API_V1 + 'redsys-threeDSMethod-return';
export const redsysThreeDSMethodLink = API + 'redsys-threeDSMethod-link-return';

// CONTACT FORM
export const contactForm = API + 'send-mail-contact';

// BROADCAST
export const broadcastAuth = API_V1 + 'broadcasting/auth';

// NOTIFICATIONS
export const notifications = API_V1 + 'notifications';
export const notification = API_V1 + 'notifications/:notification';
export const notificationTest = API_V1 + 'notifications/test/:user_id';
export const notificationEmail = (type, status) => API_V1 + `notifications/status/${type}/${status}`

// FAQ
export const faq = API + 'faq';
export const faqV1 = API_V1 + 'faq';

// DASHBOARD
export const dashboardData = API_V1 + 'dashboard/data';
export const dashboardClients = API_V1 + 'dashboard/clients';
export const dashboardCanceled = API_V1 + 'dashboard/canceled';
export const dashboardIncomes = API_V1 + 'dashboard/incomes';
export const dashboardPlan = API_V1 + 'dashboard/plan';

// SYSTEM
export const healthJobs = API_V1 + 'health-jobs';
export const healthFailedJobs = API_V1 + 'health-failed_jobs';
